import React from 'react';

const Team = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-center mb-6">Our Team</h1>
        <p className="text-center text-gray-600 max-w-2xl mx-auto">
          Team details will be updated soon.
        </p>

        <div className="mt-12 bg-blue-50 border border-blue-200 rounded-xl p-6 text-sm text-gray-700">
          Partnership Deed Date: 05 Feb 2025 · Total Capital: ₹1,00,000 · Firm Type: Partnership · Registered for SEBI Research Analyst services
        </div>
      </div>
    </div>
  );
};

export default Team;

